import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Mail, Lock, Eye, EyeOff, LogIn, ArrowLeft, AlertCircle, Loader2 } from "lucide-react";
import loginimg from "../images/logo.jpg";
import { setToken } from "./Auth.js";
import "../css/login.css"; // Importe o novo CSS
import imgFundo from "../images/Guaratingueta.png";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post("/api/login", {
        email,
        password,
      });

      if (res.data.Status === "Success") {
        setToken(res.data.Token);
        localStorage.setItem("UserRole", res.data.Role || "user");
        localStorage.setItem("UserSecretariaId", res.data.User.id_secretaria || "");
        localStorage.setItem("UserName", res.data.User.name);
        localStorage.setItem("UserId", res.data.User.id || "");
        
        // Pequeno delay para usuário ver o sucesso antes do reload
        setTimeout(() => {
            navigate("/");
            window.location.reload();
        }, 500);
      } else {
        setError(res.data.Error || "Falha na autenticação. Verifique suas credenciais.");
      }
    } catch (err) {
      console.error("Erro no login:", err);
      setError("Erro de conexão com o servidor. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper"
    style={{backgroundImage:`url(${imgFundo})`}}>
      <div className="login-card">
        
        {/* Título Institucional */}
        <div className="institution-title">Prefeitura Municipal de Guaratinguetá</div>

        {/* Logo */}
        <div className="logo-area">
          <img src={loginimg} alt="Logo Prefeitura" className="img-fluid" style={{maxHeight: '80px'}} />
        </div>

        <h1 className="login-title">Bem-vindo</h1>
        <p className="login-subtitle">Acesse o painel administrativo</p>

        {/* Mensagem de Erro */}
        {error && (
          <div className="error-box">
            <AlertCircle size={18} />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleLogin}>
          
          {/* Input Email */}
          <div className="input-group-login">
            <Mail size={20} className="icon-left" />
            <input
              type="email"
              className="form-input-login"
              placeholder="E-mail corporativo"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* Input Senha */}
          <div className="input-group-login">
            <Lock size={20} className="icon-left" />
            <input
              type={showPassword ? "text" : "password"}
              className="form-input-login"
              placeholder="Sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button 
                type="button" 
                className="btn-show-pass" 
                onClick={() => setShowPassword(!showPassword)}
                tabIndex="-1"
            >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <button type="submit" className="btn-login-submit" disabled={loading}>
            {loading ? (
              <>
                <Loader2 size={20} className="animate-spin me-2" />
                Autenticando...
              </>
            ) : (
              <>
                Entrar <LogIn size={18} className="ms-2" />
              </>
            )}
          </button>

          <button
            type="button"
            className="btn-back"
            onClick={() => navigate("/")}
          >
            <ArrowLeft size={16} /> Voltar para o início
          </button>

        </form>
      </div>
    </div>
  );
};

export default Login;